module.exports = __webpack_public_path__ + "img/programming.9507057d.jpg";